require('../navigation/anchor.js');
require('./card-suggestion.css');
const CardTactic = require('../decklist/card-tactic.js');

const markup = /* xml */ `<db:procardsuggestion>
	<table>
		<tr>
			<td>
				<db:cardpreview
					data-id='preview'
					data-property='image'
					data-ignore='1'
				></db:cardpreview>
			</td>
			<td>
				<header>
					<span data-id='name'></span>
				</header>
				<div data-id='quantityControls'>
					Quantity to Add:
					<input
						type='number'
						data-id='quantity'
						value='0'
						min='0'
						max='4'
						data-property='value'
						_readonly='readonly'
						style='width: 2.5em;'
					/>
					<div style='display: inline-block;'>
						<button data-id='quantityDec'>&larr;</button>
						<button data-id='quantityInc'>&rarr;</button>
					</div>
				</div>
				<div
					data-id='_tacticOptions'
					data-ignore='1'
					data-collection='db:cardtactic'>
				</div>
			</td>
		</tr>
	</table>
</db:procardsuggestion>`;

const ProCardSuggestion = DomClass(markup, function() {
	this.preview = "http://gatherer.wizards.com/Handlers/Image.ashx?"
		+ "multiverseid=" + this.multiverseid
		+ "&type=card";

	if (this.type?.toLowerCase().includes('basic land')) {
		delete this.__dom.quantity.max;
	}

	// should already be set by caller.
	this.tactics = this.tactics || new Set();

	if (!this.isDeckLocked) {
		this.__dom.quantityInc.onclick = () => {
			this.quantity = Math.min(4, Number(this.quantity) + 1);
		};

		this.__dom.quantityDec.onclick = () => {
			this.quantity = Math.max(0, this.quantity - 1);
		};
	} else {
		this.__dom.quantityControls.style.display = 'none';
	}

	this._tacticOptions = this.tacticOptions.map(tactic => {
		const ct = new CardTactic({
			name: tactic.name,
			selected: this.tactics.has(tactic.name)
		});
		if (this.isDeckLocked) ct.lock();

		on(ct, 'change', () => {
			if (ct.selected) {
				this.tactics.add(tactic.name);
			} else {
				this.tactics.delete(tactic.name);
			}
		});

		return ct;
	});
});

export default ProCardSuggestion;
